<template>
 
    <router-view />
</template>

<style>
#app {
  font-family: 'Montserrat', sans-serif; 
  height: 100%;
}
html, body {
    height: 100%;
}

body {
  margin: 0;
  padding: 0;
  background-color: #d9d9d9;
}
</style>
